import React from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { IconHeadphones } from "@tabler/icons-react";

const Services = () => {
  return (
    <div>
      <div
        className="relative bg-n8 pb-[60px] after:absolute after:bottom-0 after:left-0 after:right-0 after:h-1/2 after:w-full"
        style={{ backgroundColor: "rgb(0, 109, 178)", paddingTop:'1px' }}
      >
        <div className="container relative z-[2]">
          <div className="mx-auto max-w-[636px] text-center" data-aos="fade-right">
            <h5
              className="h5 text-white"
              style={{
                color: "rgb(0, 109, 178)",
                marginTop: "100px",
              }}
            >
              Professional IT services for your business
            </h5>
            <h3 className="h3 mb-4 text-title">
              We provide a wide range of IT services that ensure your company's
              success.
            </h3>
          </div>
          <div
            className="grid grid-cols-12 gap-6"
            style={{ backgroundColor: "rgb(0, 109, 178)" }}
          >
            {[
              {
                img: "assets/images/icon-1.png",
                name: "IT Solution",
                description:
                  "We deliver innovative, reliable IT solutions to boost efficiency and drive digital transformation using emerging technologies for sustainable business growth.",
              },
              {
                img: "assets/images/icon-2.png",
                name: "Web Development",
                description:
                  "Crafting responsive, user-centric websites with modern tech to elevate online presence and enhance experiences for better engagement and success.",
              },
              {
                img: "assets/images/icon-3.png",
                name: "Networking",
                description:
                  "Providing secure, high-performance network solutions for seamless connectivity, with expertly designed systems ensuring reliability and optimal business operations.",
              },
              {
                img: "assets/images/icon-4.png",
                name: "App Optimization",
                description:
                  "Enhancing app performance with cutting-edge optimization techniques to deliver superior user experiences, efficiency, and satisfaction across all platforms.",
              },
              {
                img: "assets/images/solutions/ui-ux.png",
                name: "UI / UX Design Specialization",
                description:
                  "Creating intuitive, appealing interfaces that prioritize user satisfaction and engagement, blending creativity with functionality for seamless digital experiences.",
              },
              {
                img: "assets/images/icon-6.png",
                name: "React-Front End Web Developer",
                description:
                  "Building dynamic, high-performance web apps using React for scalable frontends, ensuring fast load times and smooth user interactions.",
              },
              {
                img: "assets/images/icon-7.png",
                name: "React Native Developer",
                description:
                  "Developing cross-platform mobile apps with React Native for consistent performance, using reusable code for cost-effective, quality solutions.",
              },
              {
                img: "assets/images/icon-8.png",
                name: "Angular-Front End Web Developer",
                description:
                  "Leveraging Angular for robust, feature-rich web apps with excellent maintainability, using modular code for scalability and easy updates.",
              },
              {
                img: "assets/images/icon-9.png",
                name: ".NET FullStack Developer",
                description:
                  "Delivering secure, scalable end-to-end solutions using .NET for enterprise-grade applications, ensuring reliability and robust performance throughout.",
              },
              {
                img: "assets/images/icon-10.png",
                name: "MERN FullStack Developer",
                description:
                  "Building full-stack apps with MongoDB, Express.js, React, and Node.js for rapid development, scalability, and efficient performance delivery.",
              },
              {
                img: "assets/images/icon-11.png",
                name: "Full Stack Java Developer",
                description:
                  "Providing comprehensive Java-based solutions for robust backend and frontend development, ensuring high performance for businesses.",
              },
              {
                img: "assets/images/icon-12.png",
                name: "DevOps Advanced Certification",
                description:
                  "Implementing CI/CD pipelines and cloud infrastructure for streamlined development and deployment, enhancing efficiency across projects.",
              },
            ].map((member, index) => (
              <div
                key={index}
                className="col-span-12 sm:col-span-6 lg:col-span-3"
              >
                <div className="flex flex-col items-center rounded-xl bg-gradient-to-b from-white from-40% to-[rgb(0, 109, 178)] p-3 shadow-[rgba(0,0,0,0.05)_0px_0px_0px_1px] duration-300 hover:shadow-[rgba(86,58,255,1)_0px_0px_0px_1px] sm:p-4 md:p-5 xl:p-[30px]  min-h-[300px] " data-aos="fade-right">
                  <div className="bg-no-repeat p-8 justify-center items-center gap-4 w-full">
                    {/* <img
                      width="300"
                      height="300"
                      src={member.img}
                      alt={member.name}
                      className="rounded-full"
                    /> */}
                    <h5
                      className="h5 text-[#2712A3] m-auto"
                      style={{ color: "rgb(0, 109, 178)" }}
                    >
                      {member.name}
                    </h5>
                  </div>
                  <span className="text-title flex-grow text-center">
                    {member.description}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="relative z-[2] pt-10 lg:pt-20">
          <div className="container" data-aos="fade-right">
            <div className="grid grid-cols-12 items-center gap-6">
              <div className="col-span-12 md:col-span-6">
                <h4 className="h4 max-w-xl text-center font-semibold text-n8 md:text-start">
                  Get a 15 Minute Consultation Over Skype or Zoom!
                </h4>
              </div>
              <div className="col-span-12 md:col-span-6">
                <div className="flex justify-end">
                  <a
                    href="/contact"
                    className="btn-white"
                    style={{ color: "rgb(0, 109, 178)" }}
                  >
                    Let’s Talk Now
                    <span
                      className="flex items-center justify-center rounded-full p-1 text-n8"
                      style={{ backgroundColor: "rgb(0, 109, 178)" }}
                    >
                      <IconHeadphones size={24} className="text-blue-700" />
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Services;
